<input
  #fileInput
  type="file"
  multiple
  class="visually-hidden"
  tabindex="-1"
  [id]="config.name"
  [accept]="allowedFileExtensions ?? '*'"
  [attr.aria-required]="isRequired ? 'true' : 'false'"
  [attr.aria-invalid]="control.hasError ? 'true' : null"
  (change)="change($event)"
/>

<label [for]="config.name">{{ 'file.label.title' | translate }}</label>
@for (file of uploadedFiles; track file) {
  <div class="file__list">
    <div>
      <div>
        <span class="icon icon-category-abonnementen"></span>
        <p class="file__list--label">{{ file.name }}</p>
      </div>
      <button type="button" class="button file__list--remove" (click)="remove(file)">
        <i class="icon icon-ui-close"></i>
      </button>
    </div>
    <progress id="file" [value]="file.progress" [hidden]="file.progress === 100" max="100" class="progress file__list--progress"></progress>
  </div>
}

<div class="file__drag-and-drop" airDragAndDrop (filesDropped)="upload($event)" (click)="open($event)">
  <button type="button" class="button button--primary">
    <i class="icon icon-ui-plus d--none--sm"></i>
    @if (!uploadedFiles.length) {
      {{ 'file.label.select' | translate }}
    } @else {
      {{ 'file.label.select_another' | translate }}
    }
  </button>
  @if (!isMobile) {
    <p>{{ 'file.label.drag_and_drop' | translate }}</p>
  }
</div>
<p class="text--sm">
  {{ maxUploadSizeMBMessage }}
  @if (allowedFileExtensions) {
    {{ allowedFileExtensionsMessage }}
  }
</p>
